import { useLocation } from 'react-router-dom'

export default function useUrlSearchParams() {
  return new URLSearchParams(useLocation().search)
}
